export const REGEX = {
  NAME: /^[A-Za-z\s]+$/,
  PHONE_NUMBER: /^\d+$/,
  USER_AGENT: /iPhone|iPad|iPod|Android/i,
  AMERICAN_EXP_CARD_REGEX: /^3[47]/,
}
